export class RATINGS_BLOCK_STATUS {
  static readonly COMING_SOON = 'coming_soon';
  static readonly BE_THE_FIRST_TO_WRITE = 'be_the_first_to_write_a_review';
  static readonly REVIEW_COUNT = 'review_count';
}
